import { useTranslation } from 'react-i18next';
import { mockActiveOrders } from '@/mocks/dashboard';
import DashboardOrders from './components/DashboardOrders';

export default function OrdersPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.orders.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Track and manage your orders</p>
      </div>
      <DashboardOrders orders={mockActiveOrders} />
    </div>
  );
}